import React, { useEffect, useState } from "react";

function Nav({ method, setMethod, status, setStatus, position, setPosition }) {
  const list1 = [
    "Method Selection",
    "Aadhar Details",
    "OTP Verification",
    "ABHA Address",
    "Confirmation",
  ];
  const list2 = [
    "Method Selection",
    "Mobile Number",
    "OTP Verification",
    "ABHA Address",
    "Confirmation",
  ];

  const [list, setList] = useState(list1);

  useEffect(() => {
    if (method === "driving") {
      setList(list2);
    } else setList(list1);
  }, [method]);

  return (
    <div className="flex flex-row items-center w-full relative">
      {list.map((item, index) => (
        <React.Fragment key={item}>
          <div className="flex flex-col items-center">
            <div className="flex flex-row items-center gap-3">
              <div
                className={`rounded-full w-8 h-8 flex justify-center items-center z-10 ${
                  status === item
                    ? "bg-[var(--primary)]"
                    : index < position
                    ? "bg-[var(--abha-old-nav-bg)] text-white"
                    : "bg-[var(--abha-nav-bg)]"
                }`}
              >
                <span
                  className={`${
                    status === item
                      ? "text-white"
                      : index < position
                      ? "text-white"
                      : "text-[var(--abha-nav-fg)]"
                  } text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-button-fw)]`}
                >
                  {index + 1}
                </span>
              </div>
              <span
                className={`${
                  status === item
                    ? "text-[var(--primary)]"
                    : index < position
                    ? "text-[var(--abha-old-nav-bg)]"
                    : "text-[var(--abha-nav-fg)]"
                } text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-button-fw)] whitespace-nowrap`}
              >
                {item}
              </span>
            </div>
          </div>
          {index < list.length - 1 && (
            <div
              className={`flex-1 h-0.5 mx-4 ${
                status === item
                  ? "bg-[var(--primary)]"
                  : index < position
                  ? "bg-[var(--abha-old-nav-bg)]"
                  : "bg-[var(--abha-nav-bg)]"
              }`}
            ></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );

  //   return (
  //     <div className="flex flex-row justify-between w-full">
  //       {list.map((item, index) => (
  //         <div className="flex flex-row items-center gap-3">
  //           <div
  //             className={` ${
  //               status === item
  //                 ? "bg-[var(--primary)]"
  //                 : "bg-[var(--abha-nav-bg)]"
  //             } rounded-full w-8 h-8 flex justify-center items-center`}
  //           >
  //             <label
  //               className={`
  //                 ${status === item ? "text-white" : "text-[var(--abha-nav-fg]"}
  //                 text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-button-fs)] w-full`}
  //             >
  //               {index + 1}
  //             </label>
  //           </div>
  //           <label
  //             className={` ${
  //               status === item
  //                 ? "text-[var(--primary)]"
  //                 : "text-[var(--abha-nav-fg)]"
  //             }  text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-button-fs)] w-full`}
  //           >
  //             {item}
  //           </label>
  //         </div>
  //       ))}
  //     </div>
  //   );
}

export default Nav;
